module.exports = __webpack_public_path__ + "static/img/index_bg_8.12fd406.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/topImg/index_bg_8.jpg
// module id = R6dU
// module chunks = 9